import { RealtimeClient } from "./RealtimeClient";
import { RestClient } from "./restClient";

export class NotificationService {
	constructor(options) {
		this._options = options;
		this._rc = new RealtimeClient();
		this._restClient = new RestClient();
	}

	streamMyActiveNotifications(callback) {
		const args = {
			filterType: "active-by-user"
		};
		return this._rc.subscribe("ecosystem", "/notifications", args, function (msg) {
			const response = JSON.parse(msg);
			if (response) {
				if (callback) {
					callback(null, response);
				}
			}
		});
	}

	async closeNotification(notificationId, callback) {
		const url = `/ecosystem/api/notifications/${notificationId}/close`;
		return this._restClient.exec_put(url, null, callback);
	}

	async closeBulkNotifications(ids, callback) {
		const url = "/ecosystem/api/notifications/closebulk";
		const body = JSON.stringify({ ids });
		return this._restClient.exec_put(url, body, callback);
	}

	async getMyActiveNotifications(callback) {
		return this._restClient.exec_get("/ecosystem/api/notifications", callback);
	}
}
